import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { FechaSegunPeriodoInput } from 'sharedComponents/inputs/date'

const FechaEmisionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FEC. EMISION' htmlFor='date-fechaEmision' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaEmision'>
          {({ field }) => (
            <FechaSegunPeriodoInput
              {...field}
              id='date-fechaEmision'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
